'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @flow
var footer = exports.footer = {
  apps_links_title: 'Descárgate la App',
  apps_links_order: '["google","apple"]',

  google_url: 'https://play.google.com/store/apps/details?id=com.tutellus.mobile',
  google_title: 'En Google Play',
  google_image: 'https://lib.tutellus.com/images/badge-google-play.svg',
  apple_url: 'https://itunes.apple.com/us/app/tutellus-cursos-online/id1082996000',
  apple_title: 'En Apple Store',
  apple_image: 'https://lib.tutellus.com/images/badge-app-store.svg',

  info_links_title: 'Información',
  info_links_order: '["howitworks","certificates","give","subscription","api", "channels"]',

  tutellus_links_title: 'Tutellus',
  tutellus_links_order: '["us","teachers","help"]',
  howitworks_url: '/informacion/como-funciona',
  howitworks_title: 'Cómo funciona',
  certificates_url: '/informacion/certificados',
  certificates_title: 'Certificados',
  give_url: '/informacion/regala',
  give_title: 'Regala',
  subscription_url: '/informacion/unlimited',
  subscription_title: 'Suscripción',
  api_url: '/informacion/afiliados',
  api_title: 'API Afiliados',
  channels_url: '/canales',
  channels_title: 'Canales',

  us_url: '/informacion/nosotros',
  us_title: 'Nosotros',
  teachers_url: '/informacion/profesores',
  teachers_title: 'Profesores',
  help_url: 'https://tutellus.zendesk.com/hc/es',
  help_title: 'Ayuda',

  contact_email_title: 'E-mail',
  contact_email_description: 'hola@tutellus.com',
  contact_phone_title: 'Teléfono',
  contact_phone_description: '+34 91 005 2511',

  copyright: '<b>&copy; 2018 Tutellus. Todos los derechos reservados</b> <a href="https://www.tutellus.com/informacion/terminos-y-condiciones" target="_blank">Consulta nuestros Términos, condiciones y política de cookies.</a> <a href="http://www.stackscale.es/" target="_blank">Hosting en cloud privado con Stackscale</a>',
  facebook_url: 'https://es-es.facebook.com/tutellus',
  twitter_url: 'https://twitter.com/tutellus',
  instagram_url: 'https://instagram.com/tutellus'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/es/footer.js
// module id = 697
// module chunks = 0